import { API_URL, AUDITLOG_PATH } from '../../environment';
  
  const AuditLogService = (transactionId) => {
 
    const _getAuditLog = async () => {
        
      // Prepare API URL
      const url = API_URL + AUDITLOG_PATH + transactionId;
  
      try {
        debugger
        // Access and serialize the response
        const response = await fetch(url, { method: 'GET', timeout: 5000 });
        const responseBody = await response.json();
        return responseBody;
      } catch (error) {
        console.error(error);
      };
    };
  
  
    return {
      getAuditLog: _getAuditLog,
    };
  };
  
  export default AuditLogService;